export default __webpack_public_path__ + "static/media/Home.e0714153.svg";